import { all, call, put, takeLatest } from 'redux-saga/effects';
import envConfig from '../../config';
import {
  updateCurrentUser,
  updateDisplayCurrency,
  updateProfileWizardActiveKey,
  fetchCurrentUser,
  fetchConnectHashedEmail,
} from '../routines';

import { request } from '../../common/util/RestClient';
import { GTM_CONNECT_PUBLISH } from '../../common/GoogleTagManager/GoogleTagManager';

export function* updateCurrentUserSaga({ payload }) {
  try {
    const { userId, activeKey, ...data } = payload;
    const URL = `${envConfig.APIG_URL}user-management/users/${userId}`;
    const config = {
      method: 'PATCH',
      payload: data,
    };
    yield call(request, URL, config);
    yield put(updateCurrentUser.success({ user: data }));
    if (activeKey) {
      yield put(updateProfileWizardActiveKey.trigger({ activeKey }));
    }
  } catch (error) {
    yield put(updateCurrentUser.failure({ error }));
  }
}

export function* updateDisplayCurrencySaga({ payload }) {
  try {
    const { userId, ...data } = payload;
    const URL = `${envConfig.APIG_URL}user-management/users/${userId}`;
    const config = {
      method: 'PATCH',
      payload: data,
    };
    yield call(request, URL, config);
    yield put(
      updateDisplayCurrency.success({
        user: data,
        successMessage: 'Successfully updated display currency.',
      })
    );
  } catch (error) {
    yield put(updateDisplayCurrency.failure({ error }));
  }
}

export function* fetchCurrentUserDetails({ payload }) {
  try {
    const { username } = payload;
    const url = `${
      envConfig.APIG_URL
    }user-management/users?username=${encodeURIComponent(username)}`;
    const userDetails = yield call(request, url, null);
    yield put(fetchCurrentUser.success({ user: userDetails.data.users[0] }));
  } catch (error) {
    yield put(fetchCurrentUser.failure({ error }));
  }
}

export function* fetchConnectHashedEmailSaga() {
  try {
    const url = `${envConfig.APIG_URL}users/get-connect-hashed-email`;
    const user = yield call(request, url, null);
    GTM_CONNECT_PUBLISH(user.data);
    yield put(fetchConnectHashedEmail.success({ user }));
  } catch (error) {
    yield put(fetchConnectHashedEmail.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchCurrentUser.TRIGGER, fetchCurrentUserDetails),
    takeLatest(updateCurrentUser.TRIGGER, updateCurrentUserSaga),
    takeLatest(updateDisplayCurrency.TRIGGER, updateDisplayCurrencySaga),
    takeLatest(fetchConnectHashedEmail.TRIGGER, fetchConnectHashedEmailSaga),
  ]);
}
